"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

interface CookieConsentProps {
  cbid: string;
}

export default function CookieConsent({ cbid }: CookieConsentProps) {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Sprawdź czy użytkownik nie ma włączonego AdBlockera
    const testElement = document.createElement("div");
    testElement.innerHTML = "&nbsp;";
    testElement.className = "adsbox";
    document.body.appendChild(testElement);

    const isBlocked = testElement.offsetHeight === 0;
    document.body.removeChild(testElement);

    if (!isBlocked) {
      setShouldLoad(true);
    } else {
      console.warn("AdBlocker detected, Cookiebot may not load properly");
      // Możesz pokazać komunikat użytkownikowi
    }
  }, []);

  if (!shouldLoad) {
    return null;
  }

  return (
    <Script
      id="Cookiebot"
      async
      strategy="afterInteractive"
      src="https://consent.cookiebot.com/uc.js"
      data-cbid={cbid}
      data-blockingmode="auto"
      type="text/javascript"
      onError={() => {
        console.warn("Cookiebot script blocked or failed to load");
      }}
    />
  );
}
